import styled from 'styled-components';

export const CheckoutMethodRadioStyled = styled.div`
  overflow: hidden;
  display: flex;
  overflow-wrap: anywhere;
  word-break: break-word;
  flex-direction: row;
  padding: 0.5rem;
  border-radius: 0.75rem;
  user-select: none;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  .est-text {
    margin-left: 8px;
  }
  .Polaris-Text--root {
    font-size: 12px;
  }
  input {
    cursor: pointer;
  }
  .shipping-privacy-href:hover {
    color: ${(props) => props.color};
  }
  .ot-est-lable-checkout-input {
    top: 15px !important;
  }
`;
